// Error copy uses non-breaking spaces and hyphens to control line wraps, and the two forms do not
// use them identically. Segment needs one plain string per error to group the forms together.
function normalizeErrorMessage(message: string): string {
  return message.replaceAll(' ', ' ').replaceAll('‑', '-');
}

export { normalizeErrorMessage };
